export default __webpack_public_path__ + "media/stadium.2cb358ea.mp3";